import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutPixelParams, checkoutUrl } from '../data/copy';
import { trackPixelEvent } from '../utils/metaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  size?: 'default' | 'large';
  variant?: 'primary' | 'outline';
  className?: string;
}
const variants = {
  primary: 'bg-cta text-on-cta hover:bg-cta-hover focus-visible:outline-cta',
  outline: 'border border-accent/60 text-accent hover:border-accent hover:bg-accent/10 focus-visible:outline-accent'
};
export function CtaButton({
  children,
  href = checkoutUrl,
  size = 'default',
  variant = 'primary',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'large' ? 'px-5 py-4 text-base min-[400px]:text-lg sm:px-8 sm:text-xl' : 'px-5 py-3.5 text-lg sm:px-6';
  const handleClick = () => {
    // Only checkout links count as a purchase start.
    if (href !== checkoutUrl) return;
    trackPixelEvent('InitiateCheckout', checkoutPixelParams);
  };
  return <a href={href} onClick={handleClick} className={`group inline-flex items-center justify-center max-w-full gap-2.5 whitespace-nowrap rounded-full font-display font-bold uppercase leading-none tracking-wide transition-[background-color,border-color,color,transform] duration-150 ease-out hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 active:translate-y-0 ${variants[variant]} ${sizing} ${className}`} data-id="element-47" data-mp="35y7kyl1od925">
      <span data-id="element-48" data-mp="3sxlw2vdw193e">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" strokeWidth={2.4} aria-hidden="true" data-id="element-49" data-mp="3swu03jgdp9cl" />
    </a>;
}